import { Fragment, ReactElement, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import FormFilter from './form';

const FilterResearchTypePractice = (): ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="filter-practice-content"
          id="panel-filter-practice-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri di ricerca</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormFilter />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

FilterResearchTypePractice.displayName = 'Research Register - Filter component';

export default FilterResearchTypePractice;
